import React from "react";
import EthereumContext from "../context/EthereumContext";
import Warning from "../components/Warning";
import Error from "../components/Error";
import Success from "../components/Success";
import Info from "../components/Info";
import ButtonBar from "../components/ButtonBar";
import deepEqual from "deep-equal";
import Form from "../components/Form";
import Address from "../basic/Address";
import Accordeon from "../components/Accordeon";
import Item from "../components/Item";
import Progress from "../components/Progress";
import Close from "../components/Close";
import HelpButton from "../components/HelpButton";
import Container from "../components/Container";
import Card from "../components/Card";
import LandingPage from "../LandingPage";
import { ethers, utils } from "ethers";
import openWallet from "../media/open-vault.mp4";
import openWalletTable from "../media/loading.png";
import QRCode from "../components/QRCode";
import Unveal from "../components/Unveal";
import QrReader from "react-qr-reader";
import ReactPasswordStrength from "react-password-strength";
import About from "../About";
import {
  name as PackageName,
  version as PackageVersion,
  homepage as PackageHomepage,
} from "../../package.json";
import dateFormat from "dateformat";
import Select from "../components/Select";
import Option from "../components/Option";
import SwaggerClient from "swagger-client";
import bityAPI from "../bity/exchange_api_v2.openapi.yaml";
import Copy from "../components/Copy";
import Note from "../components/Note";
import Tabs from "../components/Tabs";
import {
  mdiWalletPlus,
  mdiPlusCircle,
  mdiMinusCircle,
  mdiFileDocumentEdit,
  mdiTextBoxPlus,
  mdiDownload,
} from "@mdi/js";
import Icon from "@mdi/react";
import { withTranslation } from "react-i18next";
import StepsToCoin from "../StepsToCoin";
import iban from "iban";
import lib from "../lib";

class WalletImpl extends React.Component {
  state = {
    bity: null,
    error: null,
    warning: null,
    success: null,
    info: null,
    timeoutUpdate: null,
    waitForOrderReady: null,
    progress: null,
    operation: null,
    qrscan: false,
    accepted: null,
    password: "",
    password2: "",
    passwordValid: false,
    files: [],
    backupname: "",
    privateKey: "",
    mnemonic: "",
    gasPrice: ethers.BigNumber.from(0),
    payGas: ethers.BigNumber.from(21000),
    encryptedWallets: null,
    wallets: null,
    balances: [],
    fiats: [],
    fiatSum: 0,
    history: [],
    account: null,
    amount: "0.0",
    receiver: "",
    newaccount: false,
    loading: false,
    lock: false,
    walletDialog: false,
    needBackup: false,
    lastBackup: null,
    currencies: [],
    currency: 0,
    buyCurrencyOption: 0,
    amountEther: "0.0",
    amountEtherMin: 0,
    amountFiat: 0,
    amountFiatMin: 0,
    tradingFee: 0,
    iban: "",
    bityPayment: null,
    orders: [],
    balancesLoaded: 0,
    failed: false,
  };

  static getDerivedStateFromError(error) {
    return {
      error: {
        heading: "Unexpected Error",
        message: error.message ?? error.toString(),
        error,
      },
      failed: true,
    };
  }
  componentDidCatch(error, errorInfo) {
    console.error(
      "Error in Component Caught!",
      "error:",
      error,
      "errorInfo:",
      errorInfo
    );
  }
  componentDidMount = () => {
    if ("accepted" in localStorage)
      this.updateState({ accepted: lib.parse(localStorage.accepted, true) });
    if ("needBackup" in localStorage)
      this.updateState({
        needBackup: lib.parse(localStorage.needBackup, true),
      });
    if ("lastBackup" in localStorage)
      this.updateState({
        lastBackup: lib.parse(localStorage.lastBackup, true),
      });
    new SwaggerClient(bityAPI, {
      requestInterceptor: (req) => {
        req.headers["X-Client-Id"] = "53d86600-d6db-44c0-b96e-97ef75524a19";
        return req;
      },
    }).then(
      (bity) => {
        SwaggerClient.http.withCredentials = true;
        this.updateState({ bity });
        bity.apis.Currencies.get_currencies({ tags: ["fiat"] }).then(
          (res) =>
            this.updateState({
              currencies: res.obj.currencies,
              currency: res.obj.currencies.findIndex(
                (v) => v.code === this.props.options.currency
              ),
            }),
          (error) => this.error(this.props.t("error.currencies"), error)
        );
      },
      (error) => this.error(this.props.t("error.bity"), error)
    );
    this.providerChange();
    this.props.setLogoutCallback(this.logout);
    this.props.setPurgeCallback(this.purgeData);
    this.updateLogout();
  };
  componentDidUpdate = (props) => {
    if (props.provider !== this.props.provider)
      this.providerChange(props.provider);
    if (props.options.currency !== this.props.options.currency) {
      this.currencyChange(props.options.currency);
      this.setState({
        currency: this.state.currencies.findIndex(
          (v) => v.code === props.options.currency
        ),
      });
    }
  };
  componentWillUnmount = () => {
    if (this.state.timeoutUpdate) clearTimeout(this.state.timeoutUpdate);
    if (this.state.waitForOrderReady)
      clearTimeout(this.state.waitForOrderReady);
  };
  accept = () => {
    let accepted = new Date();
    localStorage.accepted = JSON.stringify(accepted);
    this.updateState({ accepted });
  };
  cancel = () => this.updateState({ account: null });
  error = (heading, error, message = error.toString()) => {
    console.error({ heading, message, error });
    if (typeof error === "string") {
      message = error;
      error = null;
    }
    this.updateState({
      error: { heading, message, error },
      lock: false,
      operation: null,
      progress: null,
      success: null,
    });
  };
  warning = (heading, message) => {
    if (this.state.timeoutWarning) clearTimeout(this.state.timeoutWarning);
    console.warning({ heading, message });
    this.updateState({ warning: { heading, message } });
  };
  success = (heading, message, from = null, to = null) => {
    this.updateState({
      success: { heading, message, from, to },
      lock: false,
      operation: null,
      progress: null,
      error: null,
    });
  };
  info = (heading, message) => {
    if (this.state.timeoutInfo) clearTimeout(this.state.timeoutInfo);
    console.info({ heading, message });
    this.updateState({
      info: { heading, message },
    });
  };
  abortableProgress = (num = 0, max = 1) => {
    let progress = this.progress(num, max);
    return (p, operation = null) => {
      if (progress && this.state.loading) return progress(p, operation);
      progress = null;
    };
  };
  progress = (num = 0, max = 1) => {
    return (p, operation = null) => {
      let progress = this.state.progress
        ? this.state.progress
        : { percent: 0, p: [] };
      progress.p[num] = p;
      progress.percent =
        (100 * progress.p.reduce((sum, val) => sum + val, 0)) / max;
      this.updateState((prev) => {
        if (!prev.progress)
          return {
            progress,
            operation: operation ? operation : prev.operation,
          };
        prev.progress.p[num] = p;
        return {
          progress: { percent: progress.percent, p: prev.progress.p },
          operation: operation ? operation : prev.operation,
        };
      });
    };
  };
  filename = () => {
    let browser = navigator.userAgent
      .replace(/[^-.0-9a-zA-Z]+/g, "_")
      .replace(/^_/, "")
      .replace(/_$/, "");
    let date = dateFormat(new Date(), "yyyy-mm-dd-HH.MM");
    return date + "-" + browser + "-" + PackageName + "-backup.json";
  };
  format = (wei) => {
    try {
      return utils.commify(utils.formatEther(wei));
    } catch (e) {
      return 0;
    }
  };
  buyEther = async () => {
    try {
      let progress = this.progress();
      let num = 0,
        max = 6;
      progress(++num / max, this.props.t("operation.order"));
      let requestBody = {
        input: {
          currency: this.state.currencies[this.state.currency].code,
          iban: this.state.iban,
          type: "bank_account",
        },
        output: {
          currency: "ETH",
          crypto_address: this.state.wallets.ethereum[this.state.account]
            .address,
          type: "crypto_address",
        },
      };
      if (this.state.buyCurrencyOption === 0)
        requestBody.output.amount = this.state.amountEther;
      else requestBody.input.amount = this.state.amountFiat;
      let res = await this.state.bity.apis.Orders.place_order(
        {},
        { requestBody }
      );
      progress(++num / max, this.props.t("operation.retrieveconfirmation"));
      let orderid = res.headers.location.replace(/^\/.*\//, "");
      res = await this.state.bity.apis.Orders.list_orders();
      progress(++num / max, this.props.t("operation.signconfirmation"));
      let order = res.obj.orders.filter((v) => v.id === orderid);
      if (order.length !== 1)
        return this.error(
          this.props.t("error.buy"),
          this.props.t("errormsg.confirmationfailed")
        );
      let signed = await this.state.wallets.ethereum[
        this.state.account
      ].signMessage(order[0].message_to_sign.body);
      progress(++num / max, this.props.t("operation.sendsigned"));
      res = await this.state.bity.apis.Orders.sign_proof_of_ownership_message(
        { order_uuid: order[0].id },
        { requestBody: signed }
      );
      progress(++num / max, this.props.t("operation.instructions"));
      res = await this.state.bity.apis.Orders.get_order_details({
        order_uuid: orderid,
      });
      progress(++num / max, "verify order result");
      let bityPayment = res.obj;
      if (
        !(
          "input" in bityPayment &&
          "amount" in bityPayment.input &&
          "currency" in bityPayment.input &&
          "iban" in bityPayment.input &&
          "output" in bityPayment &&
          "amount" in bityPayment.output &&
          "currency" in bityPayment.output &&
          "payment_details" in bityPayment &&
          "iban" in bityPayment.payment_details &&
          "recipient" in bityPayment.payment_details &&
          "reference" in bityPayment.payment_details &&
          "swift_bic" in bityPayment.payment_details
        )
      )
        return this.error(
          this.props.t("error.buy"),
          this.props.t("errormsg.wrongresponse", {
            error: JSON.stringify(bityPayment, null, 4),
          })
        );
      this.updateState({
        amountEther: 0,
        amountFiat: 0,
        amountFiatMin: 0,
        amountEtherMin: 0,
        bityPayment,
        progress: null,
        operation: null,
      });
    } catch (error) {
      if (error.response?.obj?.errors?.find((e) => e.code === "exceeds_quota"))
        this.error(this.props.t("error.buy"), this.props.t("error.bityquota"));
      else this.error(this.props.t("error.buy"), error);
    }
  };
  estimateBuy = async (currency) => {
    if (this.state.buyCurrencyOption === 0)
      this.estimateBuyFromEther(null, currency);
    else this.estimateBuyFromFiat(null, currency);
  };
  estimateBuyFromEther = async (ether = null, currency = 0) => {
    if (!(ether !== null ? ether : this.state.amountEther)) return;
    try {
      let res = await this.state.bity.apis.Orders.estimate_order_amount(
        {},
        {
          requestBody: {
            output: {
              amount: ether !== null ? ether : this.state.amountEther,
              currency: "ETH",
            },
            input: {
              currency: this.state.currencies[
                currency !== null ? currency : this.state.currency
              ].code,
            },
          },
        }
      );
      this.updateState({
        amountFiat: res.obj.input.amount,
        amountEtherMin: res.obj.output.minimum_amount
          ? res.obj.output.minimum_amount
          : 0,
        amountFiatMin: res.obj.input.minimum_amount
          ? res.obj.input.minimum_amount
          : 0,
        tradingFee:
          res.obj.price_breakdown.customer_trading_fee.amount +
          " " +
          res.obj.price_breakdown.customer_trading_fee.currency,
      });
    } catch (error) {
      this.error(this.props.t("error.wrongestimation"), error);
    }
  };
  estimateBuyFromFiat = async (fiat = null, currency = null) => {
    if (!(fiat !== null ? fiat : this.state.amountFiat)) return;
    try {
      let res = await this.state.bity.apis.Orders.estimate_order_amount(
        {},
        {
          requestBody: {
            output: { currency: "ETH" },
            input: {
              amount: fiat !== null ? fiat : this.state.amountFiat,
              currency: this.state.currencies[
                currency !== null ? currency : this.state.currency
              ].code,
            },
          },
        }
      );
      this.updateState({
        amountEther: res.obj.output.amount,
        amountEtherMin: res.obj.output.minimum_amount
          ? res.obj.output.minimum_amount
          : 0,
        amountFiatMin: res.obj.input.minimum_amount
          ? res.obj.input.minimum_amount
          : 0,
        tradingFee:
          res.obj.price_breakdown.customer_trading_fee.amount +
          " " +
          res.obj.price_breakdown.customer_trading_fee.currency,
      });
    } catch (error) {
      this.error(this.props.t("error.wrongestimation"), error);
    }
  };
  balance = (i) =>
    this.state.balances[i]
      ? this.format(this.state.balances[i]) + " ETH"
      : "❓";
  fiat = (i) =>
    typeof this.state.fiats[i] !== "undefined"
      ? this.state.fiats[i] + " " + this.props.options.currency
      : "❓";
  providerChange = async (provider = this.props.provider) => {
    if (provider)
      try {
        let gasPrice = await provider.provider.getGasPrice();
        let payGas = await provider.provider.estimateGas({
          from: "0x84c969d601b86f2c17Bd42485380BC136e8Bd5ac", // random
          to: "0x1b05988AC92A18ed5d3084e91E8FC478993e407d", // random
          value: utils.parseEther("1"),
        });
        this.updateState({ gasPrice, payGas });
      } catch {}
    this.updateState({
      history: [],
      balances: [],
      fiats: [],
      fiatSum: 0,
      balancesLoaded: false,
    });
    this.update();
  };
  currencyChange = async (
    currency = this.props.options.currency,
    balances = this.state.balances
  ) => {
    let requestBody = balances
      .filter((balance) => balance && balance > 0)
      .map((balance) => ({
        output: {
          currency,
        },
        input: {
          currency: "ETH",
          amount: ethers.utils.formatEther(balance),
        },
      }));
    try {
      let res =
        requestBody.length > 0
          ? await this.state.bity.apis.Orders.estimate_order_amount_multiple(
              {},
              { requestBody }
            )
          : null;
      if (!res.ok) throw new Error("bad result", res);
      let i = 0;
      const fiats = balances.map((balance) =>
        balance && balance > 0 ? Number(res?.body?.[i++]?.output?.amount) : 0
      );
      let fiatSum = fiats.reduce((p, c) => c + p, 0);
      this.updateState({ fiats, fiatSum });
    } catch (e) {
      console.error("update fiat failed: %s", e.message, e, requestBody);
    }
  };
  update = async (w) => {
    if (this.state.timeoutUpdate) clearTimeout(this.state.timeoutUpdate);
    await this.balances(w);
    this.updateState({ timeoutUpdate: setTimeout(this.update, 10000) });
  };
  balances = async (w) => {
    try {
      if (!this.props.provider) return;
      var wallets = w || this.state.wallets;
      var balances = [];
      let history = [];
      if (!wallets || !wallets.ethereum) return;
      for (let i = 0; i < wallets.ethereum.length; ++i) {
        if (
          typeof wallets.ethereum[i] === "object" &&
          wallets.ethereum[i].address
        )
          balances[i] = await this.props.provider.provider.getBalance(
            wallets.ethereum[i].address
          );
        if (this.props.provider.etherscan) {
          history[i] = (
            await this.props.provider.etherscan.getHistory(
              wallets.ethereum[i].address,
              this.state.history[i] && this.state.history[i].length
                ? this.state.history[i][0].blockNumber + 1
                : 0
            )
          ).reverse();
          if (this.state.history[i])
            history[i] = history[i].concat(this.state.history[i]);
        }
      }
      if (!deepEqual(balances, this.state.balances)) {
        this.updateState({ balances, balancesLoaded: true });
        this.currencyChange(this.props.options.currency, balances);
      }
      if (!deepEqual(history, this.state.history)) {
        this.updateState({ history });
      }
    } catch (error) {
      console.error("Failed to get balances", error);
    }
  };
  save = async (w) => {
    try {
      this.updateState({
        error: null,
        warning: null,
        success: null,
        lock: true,
        operation: this.props.t("operation.save"),
      });
      let wallets = w || this.state.wallets;
      let encryptedWallets = this.state.encryptedWallets || { ethereum: [] };
      let changed = false;
      for (let i = 0; i < wallets.ethereum.length; ++i) {
        if (typeof encryptedWallets.ethereum[i] === "string") {
          this.progress(i, wallets.ethereum.length)(1.0);
        } else {
          changed = true;
          encryptedWallets.ethereum[i] = await this.encrypt(
            wallets.ethereum[i],
            this.state.password,
            i,
            wallets.ethereum.length
          );
        }
      }
      localStorage.wallets = JSON.stringify(encryptedWallets);
      localStorage.needBackup = JSON.stringify(changed);
      this.updateState({
        encryptedWallets,
        needBackup: changed,
        error: null,
        progress: null,
        lock: false,
        operation: null,
      });
    } catch (error) {
      this.error(this.props.t("error.save"), error);
      this.save(w);
    }
  };
  encrypt = async (wallet, password, i, max) => {
    return wallet.encrypt(
      password,
      {
        scrypt: {
          N: Math.pow(2, this.props.options.security), //131072, // The number must be a power of 2 (default: 131072)
        },
      },
      this.progress(i, max)
    );
  };
  decrypt = async (data, password, i, max) => {
    let progress = this.abortableProgress(i, max);
    let wallet = await ethers.Wallet.fromEncryptedJson(
      data,
      password,
      progress
    );
    if (wallet && this.state.loading) {
      let wallets = this.state.wallets || { ethereum: [] };
      wallets.ethereum[i] = wallet;
      this.updateState({ wallets });
      return wallet;
    }
    throw new Error(this.props.t("error.decrypt"));
  };
  load = async () => {
    try {
      this.updateState({
        loading: true,
        error: null,
        warning: null,
        success: null,
        lock: true,
        operation: this.props.t("operation.load"),
      });
      let encryptedWallets = lib.parse(localStorage.wallets);
      let wallets = { ethereum: [] };
      let password =
        this.state.password2 === ""
          ? this.state.password
          : this.state.password2;
      this.updateState({ encryptedWallets, wallets });
      wallets.ethereum = await Promise.all(
        encryptedWallets.ethereum.map((v, i) =>
          this.decrypt(v, password, i, encryptedWallets.ethereum.length)
        )
      );
      this.updateState({
        wallets,
        password,
        password2: password,
        passwordValid: true,
        loading: false,
        error: null,
        progress: null,
        lock: false,
        operation: null,
      });
      this.update(wallets);
    } catch (error) {
      this.updateState({
        password: "",
        passwordValid: false,
        wallets: null,
        loading: false,
      });
      this.error(this.props.t("error.load"), error);
    }
  };
  backup = async () => {
    try {
      this.updateState({
        error: null,
        warning: null,
        success: null,
        lock: true,
        operation: this.props.t("operation.backup"),
      });
      var data = {
        creator: {
          name: PackageName,
          version: PackageVersion,
          homepage: PackageHomepage,
        },
        file: {
          type: "application/coinwallet",
          version: "1",
        },
        files: {
          wallets: lib.parse(localStorage.wallets),
          accepted: lib.parse(localStorage.accepted),
          options: lib.parse(localStorage.options, true),
        },
      };
      var blob = new Blob([JSON.stringify(data, null, 4)], {
        type: "application/json",
      });
      var a = document.createElement("a");
      a.href = window.URL.createObjectURL(blob);
      a.download = this.filename();
      a.click();
      localStorage.needBackup = JSON.stringify(false);
      let lastBackup = new Date();
      localStorage.lastBackup = JSON.stringify(lastBackup);
      this.updateState({
        needBackup: false,
        lastBackup,
        error: null,
        progress: null,
        lock: false,
        operation: null,
      });
    } catch (error) {
      this.error(this.props.t("error.backup"), error);
    }
  };
  fileInput = async (e) => {
    this.updateState({
      operation: this.props.t("operation.preparefile"),
    });
    if (!window.FileReader)
      return this.error(
        this.props.t("error.cantrestore"),
        this.props.t("errormsg.nofileupload")
      );
    for (let i = 0; i < e.target.files.length; ++i) {
      let file = e.target.files[i];
      let reader = new FileReader();
      let name = file.name;
      this.updateState({ backupname: name });
      reader.onabort = () =>
        this.warning(
          this.props.t("warning.aborted"),
          this.props.t("warningmsg.uploadaborted", { name })
        );
      reader.onerror = (evt) => {
        reader.abort();
        this.error(this.props.t("error.readrestore"), evt.target.error);
      };
      reader.onprogress = (evt) =>
        this.progress()(Math.round(evt.loaded / evt.total));
      reader.onloadstart = () =>
        this.updateState({
          error: null,
          warning: null,
          success: null,
          operation: this.props.t("operation.loadingfile", { name }),
        });
      reader.onloadend = () => {
        let json;
        try {
          json = lib.parse(reader.result);
          if (!json) throw new TypeError(this.props.t("errormsg.emptybackup"));
        } catch (error) {
          return this.error(
            this.props.t("error.restore"),
            error,
            this.props.t("errormsg.invalidbackup")
          );
        }
        let files = this.state.files;
        files[i] = json;
        this.updateState({ files, progress: null, operation: null });
      };
      reader.readAsBinaryString(file);
    }
  };
  restore = async () => {
    try {
      this.updateState({
        error: null,
        warning: null,
        success: null,
        lock: true,
        operation: this.props.t("operation.restore"),
      });
      if (this.state.timeoutUpdate) clearTimeout(this.state.timeoutUpdate);
      let json = this.state.files[0];
      if (
        json.file &&
        json.file.type === "application/coinwallet" &&
        typeof json.files === "object"
      ) {
        for (let key in json.files) {
          let value = json.files[key];
          localStorage[key] = JSON.stringify(value);
        }
      } else {
        return this.error(
          this.props.t("error.restore"),
          this.props.t("errormsg.backupnotsupported")
        );
      }
      if ("provider" in localStorage) {
        let provider = lib.parse(localStorage.provider);
        if (this.state.provider !== provider) this.props.setProvider(provider);
      }
      let accepted = this.state.accepted;
      if ("accepted" in localStorage)
        accepted = lib.parse(localStorage.accepted);
      this.updateState({
        accepted,
        error: null,
        files: [],
        newaccount: false,
      });
      this.load();
    } catch (error) {
      this.error(this.props.t("error.restore"), error);
    }
  };
  create = (provider) => async () => {
    try {
      this.updateState({
        newaccount: false,
        error: null,
        warning: null,
        success: null,
        lock: true,
        operation: this.props.t("operation.create"),
      });
      var wallets = this.state.wallets || { ethereum: [] };
      wallets.ethereum.push(ethers.Wallet.createRandom());
      this.updateState({ wallets, error: null });
      this.update();
      this.save(wallets);
    } catch (error) {
      this.error(this.props.t("error.create"), error);
    }
  };
  importPrivateKey = (provider) => async () => {
    try {
      this.updateState({
        error: null,
        warning: null,
        success: null,
        lock: true,
        operation: this.props.t("operation.importprivkey"),
      });
      var wallets = this.state.wallets || { ethereum: [] };
      wallets.ethereum.push(new ethers.Wallet(this.state.privateKey));
      this.updateState({
        wallets,
        error: null,
        newaccount: false,
        progress: null,
        lock: false,
        operation: null,
      });
      this.update();
      this.save(wallets);
    } catch (error) {
      this.error(this.props.t("error.importprivkey"), error);
    }
  };
  importMnemonic = (provider) => async () => {
    try {
      this.updateState({
        error: null,
        warning: null,
        success: null,
        info: null,
        lock: true,
        operation: this.props.t("operation.importmnemonic"),
      });
      var wallets = this.state.wallets || { ethereum: [] };
      wallets.ethereum.push(ethers.Wallet.fromMnemonic(this.state.mnemonic));
      this.updateState({
        wallets,
        error: null,
        newaccount: false,
        progress: null,
        lock: false,
        operation: null,
      });
      this.update();
      this.save(wallets);
    } catch (error) {
      this.error(this.props.t("error.importmnemonic"), error);
    }
  };
  sendEther = (i, receiver, amount) => async () => {
    try {
      if (!this.props.provider) return;
      this.updateState({
        error: null,
        warning: null,
        success: null,
        operation: this.props.t("operation.sendether"),
      });
      var wallet = this.state.wallets.ethereum[i].connect(
        this.props.provider.provider
      );
      await wallet.sendTransaction({
        to: receiver,
        value: utils.parseEther(amount.toString()),
      });
      this.success(
        this.props.t("success.transaction"),
        this.props.t("successmsg.transaction", { amount }),
        wallet.address,
        receiver
      );
      this.updateState({
        amount: 0,
        error: null,
        receiver: "",
        progress: null,
        operation: null,
      });
      this.update();
    } catch (error) {
      this.error(this.props.t("error.sendether"), error);
    }
  };

  isInnerLink = (e, name) => {
    for (let item = e.target; item; item = item.parentElement)
      if (item.className === name) return true;
    return false;
  };

  selectAccount = (i) => (e) => {
    if (this.isInnerLink(e, "copyicon")) return; // ignore clipboard, not handled here
    this.updateState({ account: i });
  };

  updateLogout = (state = this.state) =>
    this.props.setLogoutDisabled(
      !!state.loading || !!state.lock || !!state.operation
    );

  updateState = (state, cb = null) => {
    if ("loading" in state || "lock" in state)
      this.updateLogout({ ...this.state, ...state });
    this.setState(state, cb);
  };

  logout = () =>
    !this.state.loading && !this.state.lock
      ? this.updateState({
          account: null,
          wallets: null,
          encryptedWallets: null,
          password: "",
          password2: "",
          balances: [],
          fiats: [],
          fiatSum: 0,
          balancesLoaded: false,
        })
      : null;

  mainTitle = () => (
    <Container>
      <h2>
        {this.props.t("login.maintitle")}
        <span className='subtitle'>
          {this.props.t("login.mainsubtitle")}
          <HelpButton>{this.props.t("login.claim")}</HelpButton>
        </span>
      </h2>
    </Container>
  );

  password = () => (
    <>
      <label>
        {this.props.t("password.new")}
        <HelpButton>{this.props.t("password.explain")}</HelpButton>
      </label>
      <ReactPasswordStrength
        minLength={5}
        minScore={2}
        scoreWords={[
          this.props.t("password.strength1"),
          this.props.t("password.strength2"),
          this.props.t("password.strength3"),
          this.props.t("password.strength4"),
          this.props.t("password.strength5"),
        ]}
        defaultValue={this.state.password}
        changeCallback={(v) =>
          this.updateState({ passwordValid: v.isValid, password: v.password })
        }
        inputProps={{
          autoFocus: true,
          placeholder: this.props.t("password.placeholder"),
          pattern:
            this.state.password + (this.state.passwordValid ? "" : "INVALID"),
        }}
      />
      <label>{this.props.t("password.repeattitle")}</label>
      <input
        onChange={(e) => this.updateState({ password2: e.target.value })}
        value={this.state.password2}
        placeholder={this.props.t("password.repeat")}
        type='password'
        autoComplete='off'
        pattern={this.state.password}
      />
      {this.props.t("password.help")}
    </>
  );

  newAccount = (newpwd = false) => (
    <Accordeon>
      <Item name={this.props.t("account.new")}>
        <Form
          ready={
            !newpwd ||
            (this.state.passwordValid &&
              !!this.state.password &&
              this.state.password === this.state.password2)
          }
          ok={this.create(this.props.provider)}
          okText={this.props.t("account.new")}
        >
          {newpwd ? this.password() : this.props.t("account.helpnew")}
        </Form>
      </Item>
      <Item name={this.props.t("privkey.import")}>
        <Form
          ok={this.importPrivateKey(this.props.provider)}
          okText={this.props.t("privkey.import")}
          ready={
            (!newpwd ||
              (this.state.passwordValid &&
                !!this.state.password &&
                this.state.password === this.state.password2)) &&
            !!this.state.privateKey.match(/^(0x)?[0-9A-Za-z]{64}$/)
          }
        >
          {newpwd ? this.password() : <></>}
          <label>{this.props.t("privkey.label")}</label>
          <div className='inputbutton'>
            <input
              autoFocus={!newpwd}
              onChange={(e) => this.updateState({ privateKey: e.target.value })}
              value={this.state.privateKey}
              placeholder='0xde3f3d946a8c7f452432b1ad90f7cc489efbd8138cca13730cb7b4e19faec70e'
              pattern='^(0x)?[0-9A-Za-z]{64}$'
            />
            <div
              className='button'
              onClick={() => this.updateState({ qrscan: !this.state.qrscan })}
            >
              {this.state.qrscan
                ? this.props.t("camera.close")
                : this.props.t("camera.scanqr")}
            </div>
          </div>
          {this.state.qrscan && (
            <QrReader
              delay={300}
              onError={(error) => {
                this.updateState({ qrscan: false });
                this.error(this.props.t("error.qrcode"), error, error.message);
              }}
              onScan={(privateKey) =>
                privateKey
                  ? this.updateState({ qrscan: false, privateKey })
                  : null
              }
              style={{
                width: "100%",
                maxWidth: "20em",
                textAlign: "center",
              }}
            />
          )}
        </Form>
      </Item>
      <Item name={this.props.t("mnemonic.import")}>
        <Form
          ok={this.importMnemonic(this.props.provider)}
          okText={this.props.t("mnemonic.import")}
          ready={
            (!newpwd ||
              (this.state.passwordValid &&
                !!this.state.password &&
                this.state.password === this.state.password2)) &&
            !!this.state.mnemonic
          }
        >
          {newpwd ? this.password() : <></>}
          <label>
            {this.props.t("mnemonic.label")}
            <HelpButton>{this.props.t("mnemonic.help")}</HelpButton>
          </label>
          <input
            type='text'
            autoFocus={!newpwd}
            onChange={(e) => this.updateState({ mnemonic: e.target.value })}
            value={this.state.mnemonic}
            placeholder={this.props.t("mnemonic.phrase")}
          />
        </Form>
      </Item>
      <Item
        name={this.props.t("backup.restore")}
        hide={(this.state.wallets?.ethereum?.length ?? 0) > 0}
      >
        <Form
          ready={
            !!this.state.password &&
            !!this.state.files &&
            this.state.files?.length === 1
          }
          ok={this.restore}
          okText={this.props.t("backup.restore")}
        >
          <div>{this.props.t("backup.passwordhint")}</div>
          <label>Password</label>
          <input
            autoFocus
            onChange={(e) =>
              newpwd
                ? this.updateState({ password: e.target.value })
                : this.updateState({ password2: e.target.value })
            }
            value={newpwd ? this.state.password : this.state.password2}
            placeholder={this.props.t("backup.password")}
            type='password'
          />
          <input
            type='file'
            autoFocus={!newpwd}
            required
            placeholder={this.props.t("backup.choosefile")}
            onChange={this.fileInput}
            defaultValue={this.state.backupname}
          />
          {this.state.wallets &&
          "ethereum" in this.state.wallets &&
          this.state.wallets.ethereum.length > 0 ? (
            <div>{this.props.t("backup.overwritewarning")}</div>
          ) : (
            <></>
          )}
        </Form>
      </Item>
    </Accordeon>
  );

  purgeData = () => {
    this.updateState({
      account: null,
      password: "",
      password2: "",
      accepted: null,
      needBackup: false,
      lastBackup: null,
      encryptedWallets: null,
      wallets: null,
      balances: [],
      fiats: [],
      fiatSum: 0,
      balancesLoaded: false,
    });
    localStorage.clear();
  };

  showSuccess = () => (
    <Form show={true}>
      <Close close={() => this.setState({ success: null })}>
        <Success
          heading={this.state.success.heading}
          message={
            <>
              {this.state.success.message}
              {this.state.success.from ? (
                <>
                  <h3>Sender</h3>
                  <Address address={this.state.success.from} />
                </>
              ) : (
                <></>
              )}
              {this.state.success.to ? (
                <>
                  <h3>Recipent</h3>
                  <Address address={this.state.success.to} />
                </>
              ) : (
                <></>
              )}
            </>
          }
        />
      </Close>
    </Form>
  );

  table = (rows, sum = null) => (
    <table>
      <thead>
        <tr>
          <th>{this.props.t("accounts.name")}</th>
          <th className='eth'>{this.props.t("accounts.balance")}</th>
          <th className='fiat'>
            {this.props.t("accounts.value", {
              currency: this.props.options.currency,
            })}
          </th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
      {sum !== null && rows.length > 1 ? (
        <tfoot>
          <tr>
            <th>{this.props.t("accounts.sum")}</th>
            <td className='eth'>{this.format(sum)} ETH</td>
            <td className='fiat'>
              {this.state.fiatSum + " " + this.props.options.currency}
            </td>
          </tr>
        </tfoot>
      ) : (
        <></>
      )}
    </table>
  );

  selectFromWallet = () =>
    !this.state.wallets || !this.state.wallets.ethereum ? (
      <></>
    ) : (
      <Form show={this.state.walletDialog}>
        <Close
          active={this.state.walletDialog}
          close={() => this.updateState({ walletDialog: false })}
        >
          {this.table(
            this.state.wallets.ethereum.map((v, i) =>
              i !== this.state.account && typeof v === "object" && v.address ? (
                <tr
                  key={i}
                  className='clickable'
                  onClick={() =>
                    this.updateState({
                      receiver: v.address,
                      walletDialog: false,
                    })
                  }
                >
                  <td>
                    <Address address={v.address} nocopy />
                  </td>
                  <td className='eth'>{this.balance(i)}</td>
                </tr>
              ) : (
                <></>
              )
            )
          )}
        </Close>
      </Form>
    );

  account = (i) =>
    this.state.wallets && (
      <Close
        close={() => this.updateState({ account: null })}
        closeText={this.props.t("account.close")}
      >
        {this.props.t("account.title")}
        <Tabs
          active={
            this.props.provider.name === "mainnet" &&
            this.state.balances &&
            typeof this.state.balances[i] !== "undefined" &&
            this.state.balances[i].eq(0)
              ? 3
              : 0
          }
        >
          <Item
            name={this.props.t("account.transactions")}
            hide={!(this.state.history[i] && this.state.history[i].length)}
          >
            {this.table(
              <tr>
                <td>
                  <Address address={this.state.wallets.ethereum[i].address} />
                </td>
                <td className='eth'>{this.balance(i)}</td>
                <td className='fiat'>{this.fiat(i)}</td>
              </tr>
            )}
            <table className='transactions'>
              <thead>
                <tr>
                  <th>{this.props.t("transaction.date")}</th>
                  <th>{this.props.t("transaction.address")}</th>
                  <th className='eth'>{this.props.t("transaction.fee")}</th>
                  <th className='eth'>{this.props.t("transaction.amount")}</th>
                </tr>
              </thead>
              <tbody>
                {this.state.history[i] &&
                  this.state.history[i].map((v, id) => (
                    <tr
                      className={
                        v.creates
                          ? "created"
                          : v.data !== "0x"
                          ? "interaction"
                          : this.state.wallets.ethereum[i].address === v.from
                          ? "payed"
                          : this.state.wallets.ethereum[i].address === v.to
                          ? "received"
                          : "unknown"
                      }
                      key={id}
                    >
                      <td>{new Date(v.timestamp * 1000).toLocaleString()}</td>
                      <td>
                        <div className='oneline'>
                          {v.creates ? (
                            <>
                              <Icon path={mdiTextBoxPlus} />
                              {" " + this.props.t("transaction.create")}
                            </>
                          ) : v.data !== "0x" ? (
                            <>
                              <Icon path={mdiFileDocumentEdit} />
                              {" " + this.props.t("transaction.interaction")}
                            </>
                          ) : this.state.wallets.ethereum[i].address ===
                            v.from ? (
                            <>
                              <Icon path={mdiMinusCircle} />
                              {" " + this.props.t("transaction.pay")}
                            </>
                          ) : this.state.wallets.ethereum[i].address ===
                            v.to ? (
                            <>
                              <Icon path={mdiPlusCircle} title='received' />
                              {" " + this.props.t("transaction.receive")}
                            </>
                          ) : (
                            this.props.t("transaction.unknown")
                          )}
                        </div>
                        {v.creates ? (
                          <Address address={v.creates} />
                        ) : this.state.wallets.ethereum[i].address === v.from &&
                          v.to ? (
                          <Address address={v.to} in />
                        ) : this.state.wallets.ethereum[i].address === v.to &&
                          v.from ? (
                          <Address address={v.from} out />
                        ) : (
                          this.props.t("transaction.unknown")
                        )}
                      </td>
                      <td className='eth'>
                        <div className='oneline'>
                          {this.format(v.gasPrice.mul(v.gasLimit))}
                        </div>
                      </td>
                      <td className='eth'>
                        <div className='oneline'>
                          {(this.state.wallets.ethereum[i].address === v.from
                            ? "-"
                            : this.state.wallets.ethereum[i].address === v.to
                            ? "+"
                            : "") + this.format(v.value)}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </Item>
          <Item
            name={this.props.t("account.sendether")}
            hide={
              !(
                this.state.balances &&
                typeof this.state.balances[i] !== "undefined" &&
                this.state.balances[i].gt(
                  this.state.payGas.mul(this.state.gasPrice)
                )
              )
            }
          >
            {this.table(
              <tr>
                <td>
                  <Address address={this.state.wallets.ethereum[i].address} />
                </td>
                <td className='eth'>{this.balance(i)}</td>
                <td className='fiat'>{this.fiat(i)}</td>
              </tr>
            )}
            {this.state.balances &&
            typeof this.state.balances[i] !== "undefined" ? (
              <Form
                ok={this.sendEther(i, this.state.receiver, this.state.amount)}
                okText={this.props.t("account.sendether")}
                ready={
                  !this.state.operation &&
                  this.state.receiver !==
                    this.state.wallets.ethereum[i].address &&
                  parseFloat(this.state.amount) > 0 &&
                  !!this.state.receiver.match(/^(0x)?[0-9A-Za-z]{40}$/) &&
                  this.state.balances &&
                  typeof this.state.balances[i] !== "undefined" &&
                  this.state.balances[i].gte(
                    utils
                      .parseEther(
                        this.state.amount.toString() === ""
                          ? "0"
                          : this.state.amount.toString()
                      )
                      .add(this.state.payGas.mul(this.state.gasPrice))
                  )
                }
              >
                <label>{this.props.t("account.sendamount")}</label>
                <input
                  autoFocus
                  type='text'
                  pattern='^[0-9]+(\.[0-9]*)?$'
                  onChange={(e) =>
                    e.target.value.match(/^[0-9]+(\.[0-9]*)?$/) &&
                    this.updateState({ amount: e.target.value })
                  }
                  value={this.state.amount}
                />
                <ButtonBar right>
                  <span>
                    {this.props.t("account.gas", {
                      gas: this.format(
                        this.state.payGas.mul(this.state.gasPrice)
                      ),
                    })}
                  </span>
                  {this.state.balances[i] &&
                    this.state.payGas &&
                    this.state.gasPrice && (
                      <div
                        className='button'
                        onClick={() =>
                          this.updateState({
                            amount: utils.formatEther(
                              this.state.balances[i].sub(
                                this.state.payGas.mul(this.state.gasPrice)
                              )
                            ),
                          })
                        }
                      >
                        {this.props.t("account.sendmax", {
                          amount: this.format(
                            this.state.balances[i].sub(
                              this.state.payGas.mul(this.state.gasPrice)
                            )
                          ),
                        })}
                      </div>
                    )}
                </ButtonBar>
                {this.state.balances[i].lt(
                  utils
                    .parseEther(
                      this.state.amount.toString() === ""
                        ? "0"
                        : this.state.amount.toString()
                    )
                    .add(this.state.payGas.mul(this.state.gasPrice))
                ) ? (
                  <Note>{this.props.t("account.sendtoomuch")}</Note>
                ) : (
                  <></>
                )}
                <label>{this.props.t("account.receiver")}</label>
                <div className='inputbutton'>
                  <input
                    onChange={(e) =>
                      this.updateState({ receiver: e.target.value })
                    }
                    value={this.state.receiver}
                    placeholder='0xde3f3d946a8c7f452432b1ad90f7cc489efbd813'
                    pattern='^(0x)?[0-9A-Za-z]{40}$'
                  />
                  <div
                    className='button'
                    onClick={() =>
                      this.updateState({ qrscan: !this.state.qrscan })
                    }
                  >
                    {this.state.qrscan
                      ? this.props.t("camera.close")
                      : this.props.t("camera.scanqr")}
                  </div>
                  <div
                    className='button'
                    disabled={
                      !this.state.wallets ||
                      !this.state.wallets.ethereum ||
                      !this.state.wallets.ethereum.find(
                        (v, i) =>
                          i !== this.state.account &&
                          typeof v === "object" &&
                          v.address
                      )
                    }
                    onClick={() => this.updateState({ walletDialog: true })}
                  >
                    Wallet
                  </div>
                </div>
                {this.state.qrscan && (
                  <QrReader
                    delay={300}
                    onError={(error) => {
                      this.updateState({ qrscan: false });
                      this.error(
                        this.props.t("error.qrcode"),
                        error,
                        error.message
                      );
                    }}
                    onScan={(receiver) =>
                      receiver
                        ? this.updateState({ qrscan: false, receiver })
                        : null
                    }
                    style={{
                      width: "100%",
                      maxWidth: "20em",
                      textAlign: "center",
                    }}
                  />
                )}
              </Form>
            ) : (
              <></>
            )}
          </Item>
          <Item name={this.props.t("account.receiveether")}>
            {this.table(
              <tr>
                <td>
                  <Address address={this.state.wallets.ethereum[i].address} />
                </td>
                <td className='eth'>{this.balance(i)}</td>
                <td className='fiat'>{this.fiat(i)}</td>
              </tr>
            )}
            <QRCode
              copy={true}
              value={this.state.wallets.ethereum[i].address}
            />
            {this.props.provider.name === "ropsten"}
          </Item>
          <Item
            name={this.props.t("account.buyether")}
            hide={this.props.provider.name !== "mainnet"}
          >
            {this.state.bityPayment ? (
              <Form
                heading={this.props.t("buyether.pay")}
                okText={this.props.t("buyether.done")}
                ok={() => this.updateState({ bityPayment: null })}
              >
                {this.table(
                  <tr>
                    <td>
                      <Address
                        address={this.state.wallets.ethereum[i].address}
                      />
                    </td>
                    <td className='eth'>{this.balance(i)}</td>
                    <td className='fiat'>{this.fiat(i)}</td>
                  </tr>
                )}
                <p>
                  {this.props.t("buyether.instructiontop", {
                    currency: this.state.bityPayment.input.currency,
                    amount: this.state.bityPayment.input.amount,
                    iban: this.state.bityPayment.input.iban,
                  })}
                </p>
                <table>
                  <thead>
                    <tr>
                      <th colSpan='2'>{this.props.t("buyether.receiver")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className='important'>
                      <th>{this.props.t("buyether.receiveriban")}</th>
                      <td className='flex'>
                        <div>{this.state.bityPayment.payment_details.iban}</div>
                        <Copy
                          text={this.state.bityPayment.payment_details.iban}
                        />
                      </td>
                    </tr>
                    <tr className='important'>
                      <th>{this.props.t("buyether.receiver")}</th>
                      <td className='flex'>
                        <div>
                          {this.state.bityPayment.payment_details.recipient}
                        </div>
                        <Copy
                          text={
                            this.state.bityPayment.payment_details.recipient
                          }
                        />
                      </td>
                    </tr>
                    <tr className='important'>
                      <th>{this.props.t("buyether.amount")}</th>
                      <td className='flex'>
                        <div>
                          {this.state.bityPayment.input.currency +
                            " " +
                            this.state.bityPayment.input.amount}
                        </div>
                        <Copy text={this.state.bityPayment.input.amount} />
                      </td>
                    </tr>
                    <tr className='important'>
                      <th>{this.props.t("buyether.reference")}</th>
                      <td className='flex'>
                        <div>
                          <strong>
                            {this.state.bityPayment.payment_details.reference}
                          </strong>
                        </div>
                        <Copy
                          text={
                            this.state.bityPayment.payment_details.reference
                          }
                        />
                      </td>
                    </tr>
                    {"recipient_name" in
                    this.state.bityPayment.payment_details ? (
                      <tr>
                        <th>{this.props.t("buyether.receivername")}</th>
                        <td className='flex'>
                          <div>
                            {
                              this.state.bityPayment.payment_details
                                .recipient_name
                            }
                          </div>
                          <Copy
                            text={
                              this.state.bityPayment.payment_details
                                .recipient_name
                            }
                          />
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                    {"recipient_postal_address" in
                      this.state.bityPayment.payment_details &&
                    Array.isArray(
                      this.state.bityPayment.payment_details
                        .recipient_postal_address
                    ) ? (
                      <tr>
                        <th>{this.props.t("buyether.receiveraddress")}</th>
                        <td className='flex'>
                          <div>
                            {this.state.bityPayment.payment_details.recipient_postal_address.reduce(
                              (p, c) =>
                                p === null ? (
                                  <>{c}</>
                                ) : (
                                  <>
                                    {p}
                                    <br />
                                    {c}
                                  </>
                                ),
                              null
                            )}
                          </div>
                          <Copy
                            text={this.state.bityPayment.payment_details.recipient_postal_address.join(
                              "\n"
                            )}
                          />
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                    <tr>
                      <th>{this.props.t("buyether.receiverswift")}</th>
                      <td className='flex'>
                        <div>
                          {this.state.bityPayment.payment_details.swift_bic}
                        </div>
                        <Copy
                          text={
                            this.state.bityPayment.payment_details.swift_bic
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                {this.props.t("buyether.instructionbottom", {
                  currency: this.state.bityPayment.input.currency,
                  amount: this.state.bityPayment.input.amount,
                  reference: this.state.bityPayment.payment_details.reference,
                  ibanfrom: this.state.bityPayment.input.iban,
                  targetcurrency: this.state.bityPayment.output.currency,
                  targetaddress: this.state.bityPayment.output.crypto_address,
                  targetamount: this.state.bityPayment.output.amount,
                })}
              </Form>
            ) : (
              <>
                {this.table(
                  <tr>
                    <td>
                      <Address
                        address={this.state.wallets.ethereum[i].address}
                      />
                    </td>
                    <td className='eth'>{this.balance(i)}</td>
                    <td className='fiat'>{this.fiat(i)}</td>
                  </tr>
                )}
                <Form
                  okText={this.props.t("buyether.buy")}
                  ok={this.buyEther}
                  ready={
                    !this.state.operation &&
                    parseFloat(this.state.amountEther) >=
                      parseFloat(this.state.amountEtherMin) &&
                    parseFloat(this.state.amountEther) > 0.0 &&
                    parseFloat(this.state.amountFiat) >=
                      parseFloat(this.state.amountFiatMin) &&
                    parseFloat(this.state.amountFiat) > 0.0 &&
                    iban.isValid(this.state.iban)
                  }
                >
                  <label>{this.props.t("buyether.currency")}</label>
                  <select
                    defaultValue={this.state.currency}
                    onChange={(e) => {
                      this.updateState({ currency: e.target.value });
                      this.estimateBuy(e.target.value);
                    }}
                    name='option'
                  >
                    {this.state.currencies.map((v, i) => (
                      <option key={i} value={i}>
                        {v.code}
                      </option>
                    ))}
                  </select>
                  <Select
                    name='buy-currency'
                    selected={this.state.buyCurrencyOption}
                    select={(buyCurrencyOption) =>
                      this.updateState({ buyCurrencyOption })
                    }
                  >
                    <Option
                      heading={
                        this.state.buyCurrencyOption !== 0
                          ? this.props.t("buyether.amountetherestimated")
                          : this.props.t("buyether.amountether")
                      }
                      value={0}
                    >
                      <input
                        type='text'
                        pattern='^[0-9]*(\.[0-9]*)?$'
                        value={this.state.amountEther}
                        onChange={(e) => {
                          this.updateState({ amountEther: e.target.value });
                          this.estimateBuyFromEther(e.target.value);
                        }}
                      />
                      {parseFloat(this.state.amountEtherMin) > 0 &&
                      parseFloat(this.state.amountEther) <
                        parseFloat(this.state.amountEtherMin) ? (
                        <Note>
                          {this.props.t("buyether.minimumamount", {
                            currency: "ETH",
                            amount: this.state.amountEtherMin,
                          })}
                        </Note>
                      ) : (
                        <></>
                      )}
                    </Option>
                    <Option
                      heading={
                        this.state.buyCurrencyOption !== 1
                          ? this.props.t("buyether.amountfiatestimated", {
                              currency: this.state.currencies[
                                this.state.currency
                              ].code,
                            })
                          : this.props.t("buyether.amountfiat", {
                              currency: this.state.currencies[
                                this.state.currency
                              ].code,
                            })
                      }
                      value={1}
                    >
                      <input
                        type='number'
                        step='0.01'
                        value={this.state.amountFiat}
                        onChange={(e) => {
                          this.updateState({ amountFiat: e.target.value });
                          this.estimateBuyFromFiat(e.target.value);
                        }}
                      />
                      {parseFloat(this.state.amountFiatMin) > 0 &&
                      parseFloat(this.state.amountFiat) <
                        parseFloat(this.state.amountFiatMin) ? (
                        <Note>
                          {this.props.t("buyether.minimumamount", {
                            currency: this.state.currencies[this.state.currency]
                              .code,
                            amount: this.state.amountFiatMin,
                          })}
                        </Note>
                      ) : (
                        <></>
                      )}
                    </Option>
                  </Select>
                  <label>{this.props.t("buyether.iban")}</label>
                  {this.state.iban && !iban.isValid(this.state.iban) ? (
                    <Note>{this.props.t("buyether.invalidiban")}</Note>
                  ) : (
                    <></>
                  )}
                  <input
                    type='text'
                    value={this.state.iban}
                    onChange={(e) => this.updateState({ iban: e.target.value })}
                    pattern='^[a-zA-Z]{2}( *[a-zA-Z0-9]){13,30}$'
                    placeholder='CH00 0000 0000 0000 0000 0'
                  />
                  {this.props.t("buyether.help", {
                    button: this.props.t("buyether.buy"),
                  })}
                </Form>
              </>
            )}
          </Item>
          <Item
            hide={
              true ||
              !(
                this.state.balances &&
                typeof this.state.balances[i] !== "undefined" &&
                utils.formatEther(this.state.balances[i]) > 0
              )
            }
            name='Sell Ether'
          >
            {this.table(
              <tr>
                <td>
                  <Address address={this.state.wallets.ethereum[i].address} />
                </td>
                <td className='eth'>{this.balance(i)}</td>
                <td className='fiat'>{this.fiat(i)}</td>
              </tr>
            )}
            <Form buttons={<div className='button'>Estimate Prize</div>}>
              <label>Sell Ether for </label>
              <select
                defaultValue={this.state.currency}
                onChange={(e) => this.updateState({ currency: e.target.value })}
                className='w3-select'
                name='option'
              >
                {this.state.currencies.map((v, i) => (
                  <option key={i} value={i}>
                    {v.code}
                  </option>
                ))}
              </select>
              <Select name='sell-currency'>
                <Option heading='Amount in Ether' value='ether' name='currency'>
                  <input
                    type='text'
                    pattern='^[0-9]*(\.[0-9]*)?$'
                    max={
                      this.state.balances &&
                      typeof this.state.balances[i] !== "undefined" &&
                      utils.formatEther(this.state.balances[i])
                    }
                  />
                </Option>
                <Option
                  heading={
                    "Amount in " +
                    this.state.currencies[this.state.currency].code
                  }
                  value='fiat'
                  name='currency'
                >
                  <input type='number' step='0.01' />
                </Option>
              </Select>
            </Form>
          </Item>
          <Item
            hide={this.props.options.customerType === 0}
            name={this.props.t("account.privatekey")}
          >
            {this.table(
              <tr>
                <td>
                  <Address address={this.state.wallets.ethereum[i].address} />
                </td>
                <td className='eth'>{this.balance(i)}</td>
                <td className='fiat'>{this.fiat(i)}</td>
              </tr>
            )}
            <Unveal
              text={
                <Container>
                  <Card
                    icon={
                      <svg
                        viewBox='0 0 63.999998 63.999998'
                        width='64'
                        height='64'
                      >
                        <g transform='translate(-23.707797,-21.295847)'>
                          <g transform='translate(9.4077968,7.0558476)'>
                            <g transform='translate(0.0650002,-0.0300006)'>
                              <path d='M 44.38,78.21 C 43.19,78.05 42,77.93 40.81,77.73 A 31.49,31.49 0 0 1 25.3,70.37 1,1 0 0 1 25.09,69 a 0.93,0.93 0 0 1 1.43,0 30.25,30.25 0 0 0 7.67,4.85 30.1,30.1 0 0 0 33.19,-6.14 l 0.26,-0.27 a 0.53,0.53 0 0 0 0.08,-0.17 C 67.13,66.69 66.51,66.11 65.91,65.5 A 4,4 0 0 1 65,60.78 0.73,0.73 0 0 0 64.91,60.21 2.28,2.28 0 0 0 62.24,59.29 c 0,0.27 0,0.59 0,0.91 a 1,1 0 0 1 -1,1 0.94,0.94 0 0 1 -0.88,-1 c 0,-0.29 0,-0.58 0,-1 h -4.09 c -0.17,0.78 0.24,2 -1,1.95 C 54.03,61.1 54.45,60 54.32,59.24 h -4.07 c -0.14,0.76 0.24,1.9 -1,1.91 -1.24,0.01 -0.85,-1.12 -1,-1.9 h -4.01 c -0.17,0.73 0.27,1.93 -1,1.9 -1.27,-0.03 -0.8,-1.17 -1,-1.92 h -4.1 c 0,0.36 0,0.71 0,1 a 0.88,0.88 0 0 1 -0.87,0.9 0.91,0.91 0 0 1 -1,-0.85 9.81,9.81 0 0 1 0,-1.09 h -4.06 c -0.15,0.77 0.29,2 -1,1.91 -1.29,-0.09 -0.83,-1.12 -0.93,-1.95 -0.63,0 -1.27,0 -1.9,0 -0.63,0 -1.17,-0.52 -1,-1.1 a 1,1 0 0 1 1.06,-0.77 h 4.85 c 0.2,-0.8 -0.27,-2 1,-2 1.27,0 0.76,1.17 0.95,1.91 h 4.09 c 0,-0.33 0,-0.65 0,-1 a 0.92,0.92 0 0 1 1,-1 c 0.54,0 0.85,0.38 0.88,1 0,0.3 0,0.61 0,0.95 h 4.15 c 0,-0.36 0,-0.71 0,-1.06 a 0.92,0.92 0 0 1 1.84,0 c 0,0.33 0,0.66 0,1 h 4.09 c 0.2,-0.72 -0.32,-1.93 1,-1.91 1.32,0.02 0.81,1.16 1,1.92 h 4.08 c 0,-0.32 0,-0.64 0,-1 a 0.89,0.89 0 0 1 0.89,-1 0.92,0.92 0 0 1 1,0.93 c 0,0.33 0,0.66 0,1.07 0.89,0 1.72,0 2.54,0 1.84,-0.12 3.57,0 4.64,1.83 2.56,-1.1 4.41,0.08 6.05,2.08 0.22,-0.4 0.39,-0.69 0.54,-1 A 30.08,30.08 0 0 0 69.2,26.81 c -0.12,-0.14 -0.25,-0.28 -0.36,-0.43 a 0.93103437,0.93103437 0 1 1 1.48,-1.13 c 1,1.35 2.13,2.68 3,4.11 a 30.85,30.85 0 0 1 4.75,14.48 5.12,5.12 0 0 0 0.1,0.54 v 3.87 L 78,49.73 a 31.47,31.47 0 0 1 -3.92,12.19 0.5,0.5 0 0 0 0.12,0.74 c 0.67,0.64 1.33,1.31 2,2 a 2.93,2.93 0 0 1 0,4.2 c -0.43,0.45 -0.88,0.89 -1.32,1.32 a 2.94,2.94 0 0 1 -4.34,0 c -0.5,-0.49 -1,-1 -1.48,-1.54 l -0.66,0.63 a 31.57,31.57 0 0 1 -16.87,8.52 c -1.14,0.19 -2.3,0.3 -3.45,0.45 z M 69.66,66.47 72.53,63.6 C 71.7,62.77 70.82,61.86 69.9,60.99 a 2,2 0 0 0 -2.82,0 2,2 0 0 0 -0.16,2.76 c 0.9,1.01 1.89,1.9 2.74,2.72 z M 71.17,68 c 1.27,1.55 1.72,1.61 3,0.22 1.28,-1.39 1.4,-1.59 0,-3 a 1.15,1.15 0 0 0 -0.14,-0.11 z' />
                              <path d='M 14.3,44.38 C 14.44,43.26 14.54,42.12 14.74,41 A 31.8,31.8 0 0 1 38.86,15.19 c 1.61,-0.39 3.28,-0.53 4.92,-0.78 l 0.6,-0.11 h 3.87 c 1.19,0.16 2.39,0.29 3.57,0.5 a 31.49,31.49 0 0 1 15.39,7.34 1,1 0 0 1 0.22,1.42 0.94,0.94 0 0 1 -1.44,0 A 29.71,29.71 0 0 0 58.1,18.61 29.09,29.09 0 0 0 41.81,16.53 C 31.66,18.18 24,23.53 19.46,32.73 14.11,43.55 15.16,54.09 22,64 c 0.47,0.68 1,1.3 1.55,1.95 0.55,0.65 0.43,1.06 0,1.44 -0.43,0.38 -1,0.27 -1.46,-0.27 A 31.59,31.59 0 0 1 14.41,48.8 3.35,3.35 0 0 0 14.3,48.25 Z' />
                              <path d='m 32.27,42.72 a 14.71,14.71 0 0 1 0.1,-1.49 3.4,3.4 0 0 1 3.12,-2.91 c 0.64,0 1.09,0.25 1.16,0.77 0.07,0.52 -0.24,1 -0.91,1.09 A 1.62,1.62 0 0 0 34.17,42 c 0,0.57 0,1.13 0,1.69 a 1.56,1.56 0 0 0 1.61,1.62 1.54,1.54 0 0 0 1.51,-1.64 c 0,-0.43 0,-0.87 0,-1.31 a 1,1 0 0 1 0.94,-1 c 0.54,0 0.9,0.39 0.92,1 0,0.46 0,0.92 0,1.37 a 3.42,3.42 0 0 1 -3.36,3.46 3.46,3.46 0 0 1 -3.51,-3.4 c 0,-0.35 0,-0.71 0,-1.06 z' />
                              <path d='m 60.25,43.13 a 10.48,10.48 0 0 1 -0.17,1.48 3.4,3.4 0 0 1 -3.65,2.55 3.36,3.36 0 0 1 -3.07,-3.16 23.17,23.17 0 0 1 0,-2.5 3.4,3.4 0 0 1 3.23,-3.19 1,1 0 0 1 1.1,0.86 c 0,0.51 -0.3,0.88 -0.9,1 -1.16,0.21 -1.57,0.68 -1.58,1.85 0,0.6 0,1.2 0,1.81 a 1.54,1.54 0 0 0 3.06,0.18 14.53,14.53 0 0 0 0.06,-1.62 c 0,-0.65 0.34,-1 0.88,-1.07 a 1,1 0 0 1 1,1 c 0,0.25 0,0.5 0,0.75 z' />
                            </g>
                          </g>
                        </g>
                      </svg>
                    }
                  >
                    {this.props.t("account.hideprivatekey")}
                  </Card>
                </Container>
              }
            >
              <QRCode copy value={this.state.wallets.ethereum[i].privateKey} />
              {this.state.wallets.ethereum[i].mnemonic?.phrase ? (
                <>
                  <h2>{this.props.t("accounts.mnemonic")}</h2>
                  <Copy>{this.state.wallets.ethereum[i].mnemonic?.phrase}</Copy>
                </>
              ) : (
                <Info>{this.props.t("accounts.nomnemonic")}</Info>
              )}
            </Unveal>
            <Info>{this.props.t("account.restore")}</Info>
          </Item>
        </Tabs>
      </Close>
    );

  render = () => {
    var sum = ethers.BigNumber.from(0);
    if (this.state.failed)
      return (
        <Form show={true}>
          <Close close={() => this.setState({ error: null, failed: false })}>
            <Error {...this.state.error} />
          </Close>
        </Form>
      );
    return (
      <>
        {(this.state.operation || this.state.progress) && (
          <Progress
            operation={this.state.operation}
            progress={this.state.progress ? this.state.progress.percent : null}
          />
        )}
        {this.state.error ? (
          <Form show={true}>
            <Close close={() => this.setState({ error: null })}>
              <Error {...this.state.error} />
            </Close>
          </Form>
        ) : (
          <></>
        )}
        {this.state.warning ? (
          <Form show={true}>
            <Close close={() => this.setState({ warning: null })}>
              <Warning
                heading={this.state.warning.heading}
                message={this.state.warning.message}
              />
            </Close>
          </Form>
        ) : (
          <></>
        )}
        {this.state.success ? this.showSuccess() : null}
        {this.state.info ? (
          <Form show={true}>
            <Close close={() => this.setState({ info: null })}>
              <Info
                heading={this.state.info.heading}
                message={this.state.info.message}
              />
            </Close>
          </Form>
        ) : (
          <></>
        )}
        {!this.state.accepted &&
        this.state.wallets &&
        this.state.wallets.ethereum ? (
          <Form show={true}>
            <Close
              close={this.accept}
              closeText={this.props.t("disclaimer.accept")}
            >
              <About disclaimer={true} />
            </Close>
          </Form>
        ) : (
          <></>
        )}
        {this.selectFromWallet()}
        {this.state.account !== null ? (
          this.account(this.state.account)
        ) : this.state.wallets === null &&
          !("wallets" in localStorage) &&
          !this.state.loading ? (
          <>
            {this.mainTitle()}
            {this.newAccount(true)}
            <LandingPage current={1} />
          </>
        ) : this.state.wallets === null && !this.state.lock ? (
          <>
            {this.mainTitle()}
            <Form
              heading={this.props.t("login.open")}
              ready={!!this.state.password}
              ok={this.load}
              buttons={
                <div
                  className={"button " + (this.state.needBackup ? "alert" : "")}
                  onClick={this.backup}
                >
                  <Icon path={mdiDownload} />
                  {" " + this.props.t("backup.button")}
                </div>
              }
            >
              <label>
                {this.props.t("login.password")}
                <HelpButton>{this.props.t("login.help")}</HelpButton>
              </label>
              <input
                autoFocus
                onChange={(e) => this.updateState({ password: e.target.value })}
                value={this.state.password}
                placeholder={this.props.t("password.placeholder")}
                type='password'
              />
            </Form>
            <LandingPage current={3} />
          </>
        ) : this.state.newaccount && !this.state.lock ? (
          <Close
            close={() => this.updateState({ newaccount: false })}
            closeText={this.props.t("account.close")}
          >
            {this.newAccount()}
          </Close>
        ) : this.state.wallets && this.state.wallets.ethereum ? (
          <>
            <Container>
              {this.props.t("accounts.title")}
              {this.table(
                (this.state.encryptedWallets
                  ? this.state.encryptedWallets
                  : this.state.wallets
                ).ethereum.map((enc, i) => {
                  let v = this.state.wallets.ethereum[i];
                  if (typeof v !== "object" || !v.address) {
                    return (
                      <tr key={i}>
                        <td colSpan='3'>
                          {this.state.progress && this.state.progress.p[i] ? (
                            <Progress
                              progress={100 * this.state.progress.p[i]}
                              operation={this.props.t("operation.decrypt")}
                            />
                          ) : (
                            <>
                              <img
                                src={openWalletTable}
                                alt={this.props.t("accounts.waiting")}
                              />
                              {this.props.t("accounts.waiting")}
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  } else {
                    if (this.state.balances[i])
                      sum = sum.add(this.state.balances[i]);
                    return (
                      <tr
                        key={i}
                        className='clickable'
                        onClick={this.selectAccount(i)}
                      >
                        <td>
                          <Address address={v.address} />
                        </td>
                        <td className='eth'>{this.balance(i)}</td>
                        <td className='fiat'>{this.fiat(i)}</td>
                      </tr>
                    );
                  }
                }),
                sum
              )}
              <ButtonBar>
                <div
                  className='button'
                  disabled={this.state.lock}
                  onClick={() => this.updateState({ newaccount: true })}
                >
                  <Icon path={mdiWalletPlus} />
                  {" " + this.props.t("accounts.add")}
                </div>
                <div
                  className={"button " + (this.state.needBackup ? "alert" : "")}
                  disabled={this.state.lock}
                  onClick={this.backup}
                >
                  <Icon path={mdiDownload} />
                  {" " + this.props.t("backup.button")}
                </div>
              </ButtonBar>
            </Container>
            {!this.state.operation &&
            this.state.balancesLoaded &&
            this.state.balances
              .reduce((prev, cur) => prev.add(cur), ethers.BigNumber.from(0))
              .eq(0) ? (
              <StepsToCoin current={2} />
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
        {this.props.provider ? (
          <></>
        ) : (
          <Warning
            heading={this.props.t("warning.noprovider")}
            message={this.props.t("warningmsg.noprovider")}
          />
        )}
        {this.state.loading ? (
          <div className='animation'>
            <video autoPlay muted loop>
              <source src={openWallet} type='video/mp4' />
            </video>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };
}

const TranslatedWallet = withTranslation()(WalletImpl);

export default class Wallet extends React.Component {
  render = () => (
    <EthereumContext.Consumer>
      {(props) => <TranslatedWallet {...props} />}
    </EthereumContext.Consumer>
  );
}
